import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BreakpointObserver} from "@angular/cdk/layout";
import {BREAKPOINTS} from "../../../shared/constants/breakpoints";
@Component({
    selector: 'mbnm-shop-detail-product-merch',
    templateUrl: './shop-detail-product-merch.component.html',
    styleUrls: ['./shop-detail-product-merch.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShopDetailProductMerchComponent implements OnInit {
  constructor(public media: BreakpointObserver) { }

  @Input()
  product:any;

  ngOnInit() {
    if (this.product.builderButton.link === 'NONE') {
      this.product.builderButton.link = null;
    } else if (this.product.builderButton.link && this.product.builderButton.link[0] !== '/') {
      this.product.builderButton.link = '/buy/' + this.product.builderButton.link;
    }
  }

  protected readonly BREAKPOINTS = BREAKPOINTS;
}
